import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useAcomodacoesSection } from "./use-acomodacoes-section";
import { AcomodacoesSectionView } from "./view-acomodacoes-section";

export function AcomodacoesSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useAcomodacoesSection(props);

  return <AcomodacoesSectionView {...vm} />;
}

export type * from "./types-acomodacoes-section";
